"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannersCarousel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Banner = require("./components/Banner");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BannersCarousel = ({
  items,
  onOpen
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const autoplay = (0, _react.useMemo)(() => ({
    enabled: items.length > 1,
    interval: 5000
  }), [items.length]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.BANNERS_CAROUSEL),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
      autoplay: autoplay,
      navigation: _constants.navigation,
      pagination: _constants.pagination,
      slider: _constants.slider,
      propagateDragEvent: false,
      id: "top-area-banner-carousel",
      children: items.map(({
        title,
        url,
        shouldOpenInvitationOffer
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
        minWidth: "100%",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Banner.Banner, {
          title: title,
          url: url,
          onClick: shouldOpenInvitationOffer ? onOpen : undefined
        })
      }, [url, title].join('-')))
    })
  });
};
exports.BannersCarousel = BannersCarousel;